module.exports = __webpack_public_path__ + "static/media/unmute.010f6e34.svg";